import { NgModule } from "@angular/core";
import { ToggleActiveDirective } from "./toggle-active.directive";
import {PortalToBodyDirective} from './portal-to-body.directive';

@NgModule({
  declarations: [
    ToggleActiveDirective,
    PortalToBodyDirective,
  ],
  exports: [
    ToggleActiveDirective,
    PortalToBodyDirective,
  ]
})
export class UtilsModule {}
